export default __webpack_public_path__ + "static/media/applications-image-16.48cfb258.jpg";